import { Fade } from '@mui/material';
import React from 'react';

import { QBox, QStack } from '@captivateiq/quotient';

import { ChatViewEnum, useAIShellContext } from '@captivateiq/assistant/AIShellContext';
import { BrowserView } from './BrowserView';
import { ChatView } from './ChatView';
import { IntroView } from './IntroView';

// Views fully swap (rather than persisting shared DOM across the transition), so this is a
// cross-fade on the newly-mounted view — not a shared-element animation of any one piece of it.
const VIEW_TRANSITION_TIMEOUT_MS = 220;

export const ChatTab = () => {
  const { chatView } = useAIShellContext();

  return (
    <QStack
      direction="column"
      sx={{
        alignItems: 'stretch',
        height: '100%',
      }}
    >
      <Fade appear in key={chatView} timeout={VIEW_TRANSITION_TIMEOUT_MS}>
        <QBox sx={{ height: '100%' }}>
          {
            {
              [ChatViewEnum.BROWSER]: <BrowserView />,
              [ChatViewEnum.INTRO]: <IntroView />,
              [ChatViewEnum.CHAT]: <ChatView />,
            }[chatView]
          }
        </QBox>
      </Fade>
    </QStack>
  );
};
